module.exports = __webpack_public_path__ + "files/5760065aa97c646f344fd5be4c6ba577.png";